import { useQuery } from "@tanstack/react-query"
import { useGetImdf } from "../useGetImdf"
import { IServiceConfig, Service, ServiceData } from "../../../types"
import { fetchGeojson } from "../../../utils/fetchUtils"
import { prepareServicesData } from "./utils/prepareServicesData"

export const useGetServices = () => {
  const { data: imdfData } = useGetImdf()

  const query = useQuery<Service[], unknown, IServiceConfig[]>({
    queryKey: ["services"],
    queryFn: async () => {
      const response = await fetchGeojson<Service>("service")
      return response.data
    },
    select: (data) => prepareServicesData(data as ServiceData[]),
    placeholderData: [],
    refetchOnWindowFocus: false,
    enabled: !!imdfData,
  })

  return query
}
